import React from "react";

import type {
    ServerCmsTypesCategoryNavItem as CategoryNavItem,
    ServerCmsModelsPagesUpcomingProductsPageUpcomingProductTile as Tile,
    UpcomingProductsBlock as Value,
} from "@reactivated";

import { Themed } from "../../styles/themes";
import { RichTextStreamBlock } from "../RichTextStreamBlock";
import { SubcategoryTiles } from "../SubcategoryTiles";
import { UpcomingProductTile } from "./UpcomingProductTile";

import favoritesStyles from "../FavoritesContent/index.module.scss";
import styles from "./index.module.scss";

interface Props {
    value: Value;
    tiles: Tile[];
    specSheetLinkLabel: string;
    subcategoryTiles: CategoryNavItem[];
    productsPageTitle: string;
}

export const UpcomingProductsBlock = ({
    value,
    tiles,
    specSheetLinkLabel,
    subcategoryTiles,
    productsPageTitle,
}: Props) => {
    if (tiles.length === 0) {
        if (!value.empty_state_content && subcategoryTiles.length === 0) {
            return null;
        }
        return (
            <Themed theme={value.theme} tag="section">
                <RichTextStreamBlock
                    value={value.empty_state_content ?? null}
                />
                {subcategoryTiles.length > 0 && (
                    <>
                        <h2 className={favoritesStyles.subcategoryHeading}>
                            {value.browse_heading}
                        </h2>
                        <SubcategoryTiles
                            tiles={subcategoryTiles}
                            categoryTitle={productsPageTitle}
                        />
                    </>
                )}
            </Themed>
        );
    }

    return (
        <Themed theme={value.theme} tag="section">
            <ul role="list" className={styles.grid}>
                {tiles.map((tile, index) => (
                    <li key={index} className={styles.item}>
                        <UpcomingProductTile
                            tile={tile}
                            specSheetLinkLabel={specSheetLinkLabel}
                        />
                    </li>
                ))}
            </ul>
        </Themed>
    );
};
